import React, { Fragment, useEffect  } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation   } from 'react-router-dom';

import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import ContactForm from '../components/ContactForm/ContactForm';

import Homepage from './Homepage';
import About from './About';
import Courses from './Courses';
import TestimonialPage from './Testimonials';
import Contact from './Contact';

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect((history) => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const Pages = () => {
  return (
    <Router>

      <Fragment>
        <Navbar />
        <div style={{paddingTop: "90px"}}></div>
        <ScrollToTop />
        <Routes >
          <Route exact path="/About" element={<About />} />
          <Route exact path="/Courses" element={<Courses />} />
          <Route exact path="/Testimonials" element={<TestimonialPage />} />
          <Route exact path="/Contact" element={<Contact />} />
          <Route path="/" element={<Homepage />} />
        </Routes>
        <ContactForm/>
        <div style={{paddingBottom: "90px"}}></div>
        <Footer />
      </Fragment>
    </Router>
  );
};

export default Pages;